import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/shared/Navbar';
import LoginPage from './pages/LoginPage';
import ProductosPage from './pages/ProductosPage';
import AutoresPage from './pages/AutoresPage';
import NoticiasPage from './pages/NoticiasPage';
import UsuariosPage from './pages/UsuariosPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Ruta pública de login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rutas protegidas */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="min-h-screen bg-gray-100">
                  <Navbar />
                  <main className="container mx-auto p-4">
                    <Routes>
                      <Route path="/productos" element={<ProductosPage />} />
                      <Route path="/autores" element={<AutoresPage />} />
                      <Route path="/noticias" element={<NoticiasPage />} />
                      <Route path="/usuarios" element={<UsuariosPage />} />
                      <Route path="/" element={<Navigate to="/productos" replace />} />
                      <Route path="*" element={<Navigate to="/productos" replace />} />
                    </Routes>
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
